const resources = {
    new: 'NEW',
    beautyChallenges: '2 défis beauté : accumulez jusqu’à 1 000 points'
};

module.exports = function getResource(label) {
    return resources[label];
};
